import { render, staticRenderFns } from "./batchSettingsList.vue?vue&type=template&id=074f67ee&scoped=true&"
import script from "./batchSettingsList.vue?vue&type=script&lang=js&"
export * from "./batchSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./batchSettingsList.vue?vue&type=style&index=0&id=074f67ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f67ee",
  null
  
)

component.options.__file = "batchSettingsList.vue"
export default component.exports